export default __webpack_public_path__ + "static/media/sponsor-4.cc43c220.svg";